// The deliverable is a static site served from /public (index.html, style.css, main.js).
// React is intentionally neutralized so it does not interfere with the static markup.
function App() {
  return null;
}

export default App;
